var _path, _radialGradient, _path2, _linearGradient, _path3, _radialGradient2, _path4, _radialGradient3, _path5, _linearGradient2, _path6, _linearGradient3, _path7, _linearGradient4, _path8, _linearGradient5, _path9, _linearGradient6, _path10, _linearGradient7, _path11, _linearGradient8, _path12, _linearGradient9, _path13, _path14, _radialGradient4, _path15, _linearGradient10, _path16, _radialGradient5, _path17, _path18, _path19, _path20, _path21, _linearGradient11, _path22, _linearGradient12, _path23, _path24, _path25, _linearGradient13, _path26;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVolvo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 2500,
    height: 2443,
    viewBox: "0 0 44.064 43.057",
    id: "volvo",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#bcbcb6",
    d: "M22.032 7.56c3.888 0 7.344 1.584 9.864 4.104C34.488 14.184 36 17.712 36 21.6c0 3.815-1.512 7.344-4.104 9.863-2.521 2.521-5.977 4.104-9.864 4.104-3.888 0-7.344-1.584-9.936-4.104-2.521-2.52-4.104-6.048-4.104-9.863 0-3.889 1.584-7.416 4.104-9.937 2.592-2.519 6.048-4.103 9.936-4.103zm0 .216a13.77 13.77 0 0 0-9.72 4.032c-2.521 2.52-4.104 5.976-4.104 9.792 0 3.815 1.584 7.271 4.104 9.72 2.448 2.52 5.903 4.032 9.72 4.032 3.816 0 7.272-1.513 9.72-4.032 2.521-2.448 4.032-5.904 4.032-9.72 0-3.816-1.512-7.272-4.032-9.792a13.768 13.768 0 0 0-9.72-4.032z"
  })), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: -1039.188,
    cy: 1145.92,
    r: 44.665,
    gradientTransform: "matrix(1 0 0 -1 1045.93 1163.232)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.041,
    stopColor: "#fafaf8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.225,
    stopColor: "#f8f8f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.287,
    stopColor: "#dadad7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.413,
    stopColor: "#a3a4a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#7e7f7d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#686866"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.646,
    stopColor: "#5f5f5d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.739,
    stopColor: "#565754"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.899,
    stopColor: "#3b3a37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M22.032.144c4.896 0 9.432 1.655 13.032 4.392L37.44 2.16l4.176 4.176-2.376 2.448c2.664 3.6 4.176 7.992 4.176 12.744 0 11.808-9.576 21.456-21.384 21.456S.648 33.336.648 21.528C.648 9.719 10.224.144 22.032.144zm0 5.04c-9 0-16.344 7.344-16.344 16.344 0 9.072 7.344 16.344 16.344 16.344S38.376 30.6 38.376 21.528c0-9-7.344-16.344-16.344-16.344z"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: -1032.338,
    x2: -1016.324,
    y1: 1144.546,
    y2: 1139.032,
    gradientTransform: "matrix(1 0 0 -1 1045.93 1163.232)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dcdbd3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M22.032 5.112c4.536 0 8.64 1.8 11.664 4.824A16.422 16.422 0 0 1 38.52 21.6c0 4.535-1.872 8.64-4.824 11.664-3.024 2.951-7.128 4.823-11.664 4.823a16.555 16.555 0 0 1-11.664-4.823C7.416 30.24 5.544 26.135 5.544 21.6c0-4.608 1.872-8.713 4.824-11.664 2.952-3.024 7.128-4.824 11.664-4.824zm0 .216c-4.464 0-8.568 1.8-11.52 4.752S5.76 17.064 5.76 21.6c0 4.464 1.8 8.567 4.752 11.52 2.951 2.88 7.056 4.752 11.52 4.752 4.464 0 8.568-1.872 11.521-4.752a16.28 16.28 0 0 0 4.752-11.52c0-4.536-1.801-8.568-4.752-11.521a16.283 16.283 0 0 0-11.521-4.751z"
  })), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "c",
    cx: -1011.188,
    cy: 1127.921,
    r: 49.019,
    gradientTransform: "matrix(1 0 0 -1 1045.93 1163.232)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bbbcb7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808079"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M22.032 0c4.896 0 9.504 1.656 13.104 4.464l-.072.072A21.524 21.524 0 0 0 22.032.144C10.224.144.648 9.719.648 21.528c0 11.808 9.576 21.456 21.384 21.456s21.384-9.648 21.384-21.456c0-4.752-1.512-9.145-4.176-12.744l.072-.072c2.664 3.601 4.248 7.992 4.248 12.816 0 5.976-2.448 11.376-6.336 15.264-3.889 3.889-9.216 6.265-15.192 6.265A21.44 21.44 0 0 1 6.84 36.792C2.952 32.832.504 27.504.504 21.528c0-5.904 2.448-11.304 6.336-15.192C10.728 2.448 16.056 0 22.032 0z"
  })), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "d",
    cx: -1016.187,
    cy: 1133.921,
    r: 34.422,
    gradientTransform: "matrix(1 0 0 -1 1045.93 1163.232)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.157,
    stopColor: "#f1f1f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.298,
    stopColor: "#e4e4e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335,
    stopColor: "#cecfce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#aeafac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.464,
    stopColor: "#969694"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526,
    stopColor: "#858683"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.586,
    stopColor: "#7c7c79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#787976"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738,
    stopColor: "#5e5e5b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.846,
    stopColor: "#43423f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.937,
    stopColor: "#1f1f1e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M22.032 5.256c9 0 16.344 7.272 16.344 16.345 0 9-7.344 16.344-16.344 16.344S5.688 30.6 5.688 21.6c0-9.072 7.344-16.344 16.344-16.344zm0 2.304c-7.704 0-13.968 6.264-13.968 14.04 0 7.703 6.264 13.968 13.968 13.968S36 29.303 36 21.6c0-7.776-6.264-14.04-13.968-14.04z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: -1043.357,
    x2: -1043.357,
    y1: 1136.424,
    y2: 1136.545,
    gradientTransform: "matrix(1 0 0 -1 1045.93 1163.232)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#f8f8f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.427,
    stopColor: "#b1b1ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.435,
    stopColor: "#adaea8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.534,
    stopColor: "#898984"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.633,
    stopColor: "#6c6c67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.731,
    stopColor: "#53534e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.825,
    stopColor: "#3e3e3a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.916,
    stopColor: "#252523"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1b1a19"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M2.494 26.717c0 .021.005.039.016.057.009.017.024.024.046.024.016 0 .03-.004.047-.012a.237.237 0 0 0 .05-.036v-.159c-.06.01-.101.024-.124.045a.108.108 0 0 0-.035.081z",
    opacity: 0.67
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: -1040.338,
    x2: -1040.338,
    y1: 1136.88,
    y2: 1136.929,
    gradientTransform: "matrix(1 0 0 -1 1045.93 1163.232)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#f8f8f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.427,
    stopColor: "#b1b1ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.435,
    stopColor: "#adaea8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.534,
    stopColor: "#898984"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.633,
    stopColor: "#6c6c67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.731,
    stopColor: "#53534e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.825,
    stopColor: "#3e3e3a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.916,
    stopColor: "#252523"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1b1a19"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M5.542 26.262h.101v.085h-.101z",
    opacity: 0.67
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: -1040.338,
    x2: -1040.338,
    y1: 1136.776,
    y2: 1136.827,
    gradientTransform: "matrix(1 0 0 -1 1045.93 1163.232)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#f8f8f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.427,
    stopColor: "#b1b1ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.435,
    stopColor: "#adaea8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.534,
    stopColor: "#898984"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.633,
    stopColor: "#6c6c67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.731,
    stopColor: "#53534e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.825,
    stopColor: "#3e3e3a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.916,
    stopColor: "#252523"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1b1a19"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M5.542 26.364h.101v.087h-.101z",
    opacity: 0.67
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: -1042.344,
    x2: -1042.344,
    y1: 1136.424,
    y2: 1136.545,
    gradientTransform: "matrix(1 0 0 -1 1045.93 1163.232)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#f8f8f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.427,
    stopColor: "#b1b1ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.435,
    stopColor: "#adaea8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.534,
    stopColor: "#898984"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.633,
    stopColor: "#6c6c67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.731,
    stopColor: "#53534e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.825,
    stopColor: "#3e3e3a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.916,
    stopColor: "#252523"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1b1a19"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "M3.507 26.717c0 .021.006.039.016.057.009.017.024.024.046.024.016 0 .031-.004.047-.012s.032-.02.05-.036v-.159c-.06.01-.101.024-.124.045a.108.108 0 0 0-.035.081z",
    opacity: 0.67
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: -1039.812,
    x2: -1039.812,
    y1: 1136.682,
    y2: 1136.759,
    gradientTransform: "matrix(1 0 0 -1 1045.93 1163.232)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#f8f8f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.427,
    stopColor: "#b1b1ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.435,
    stopColor: "#adaea8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.534,
    stopColor: "#898984"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.633,
    stopColor: "#6c6c67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.731,
    stopColor: "#53534e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.825,
    stopColor: "#3e3e3a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.916,
    stopColor: "#252523"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1b1a19"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    d: "M5.98 26.411h.276v.131H5.98z",
    opacity: 0.67
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: -1040.398,
    x2: -1040.398,
    y1: 1134.523,
    y2: 1136.065,
    gradientTransform: "matrix(1 0 0 -1 1045.93 1163.232)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#f8f8f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.427,
    stopColor: "#b1b1ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.435,
    stopColor: "#adaea8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.534,
    stopColor: "#898984"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.633,
    stopColor: "#6c6c67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.731,
    stopColor: "#53534e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.825,
    stopColor: "#3e3e3a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.916,
    stopColor: "#252523"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1b1a19"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    d: "M8.769 25.958H1.113c.189.899.451 1.771.749 2.625h8.09a13.953 13.953 0 0 1-1.183-2.625zm-3.264.167l.059.037-.021.024v.061h.096l.021-.034.04.047-.021.024v.064h.011l.029-.037.042.054h-.084l.002.115-.037.022v-.034h-.1v.099h.076l.026-.041.04.058h-.142v.091h.124l.029-.047.045.062h-.198c0 .038.001.079.005.122l-.042.02c.002-.052.004-.099.004-.142h-.106a.072.072 0 0 0-.04.01l-.024-.027h.17v-.091h-.077c-.015 0-.024.003-.032.01l-.021-.026h.13v-.099h-.077c-.015 0-.024.003-.032.011l-.021-.028h.13v-.087h-.114c-.015 0-.024.003-.031.01l-.021-.027h.167v-.084h-.073c-.015 0-.025.004-.032.011l-.021-.027h.124a1.45 1.45 0 0 0-.003-.121zm-3.15.693h-.206v-.021h.061c.01 0 .016-.002.02-.007s.005-.011.005-.02v-.482a.034.034 0 0 0-.005-.02.027.027 0 0 0-.02-.008h-.06v-.02h.03a.147.147 0 0 0 .087-.028h.005v.557c0 .009.002.016.006.02.005.004.01.007.018.007h.062v.021h-.003zm.376-.018c-.009.013-.021.02-.034.02a.041.041 0 0 1-.029-.01.077.077 0 0 1-.016-.034.317.317 0 0 1-.049.036.118.118 0 0 1-.055.012.094.094 0 0 1-.073-.029.087.087 0 0 1-.026-.064c0-.041.014-.074.041-.101.027-.025.081-.044.162-.056v-.041a.119.119 0 0 0-.012-.056c-.009-.016-.026-.022-.055-.022s-.051.006-.062.02c-.012.013-.018.024-.013.038a.042.042 0 0 1 0 .027.023.023 0 0 1-.021.014.021.021 0 0 1-.017-.008.043.043 0 0 1-.008-.024c0-.021.012-.04.034-.059a.133.133 0 0 1 .084-.026c.035 0 .062.008.079.024.019.018.026.041.026.072v.223c0 .019.001.029.004.032s.007.005.015.005c.009 0 .016-.005.019-.015s.005-.024.005-.042h.013c.001.03-.003.052-.012.064zm.343.018h-.111v-.021h.014c.009 0 .015-.002.019-.007S3 26.78 3 26.771v-.227a.12.12 0 0 0-.013-.062.043.043 0 0 0-.039-.022.078.078 0 0 0-.049.021.184.184 0 0 0-.046.058v.233c0 .009.002.016.007.02.004.004.01.007.017.007h.013v.021h-.111v-.021h.013c.01 0 .016-.002.02-.007s.005-.011.005-.02v-.291c0-.006-.001-.013-.003-.016s-.006-.005-.011-.005h-.024v-.02h.019c.01 0 .019-.001.026-.003s.016-.007.023-.015h.005v.078a.256.256 0 0 1 .047-.05.08.08 0 0 1 .05-.017c.03 0 .052.01.066.029a.167.167 0 0 1 .021.092v.216c0 .009.002.016.007.02s.011.007.018.007h.013v.021zm.281-.026c-.016.021-.035.03-.061.03s-.046-.01-.059-.03-.021-.052-.021-.095v-.236h-.076v-.02h.021a.063.063 0 0 0 .052-.025c.014-.017.021-.043.025-.079l.002-.026h.016v.131h.105v.02h-.105v.25c0 .032.005.054.014.064.009.012.021.017.04.017a.05.05 0 0 0 .042-.021.146.146 0 0 0 .021-.062l.014.007a.172.172 0 0 1-.03.075zm.389.008c-.009.013-.02.02-.034.02-.012 0-.021-.003-.028-.01-.008-.007-.013-.019-.017-.034a.317.317 0 0 1-.049.036.113.113 0 0 1-.054.012.095.095 0 0 1-.1-.093.14.14 0 0 1 .041-.101c.027-.025.081-.044.162-.056v-.041a.119.119 0 0 0-.012-.056c-.008-.016-.026-.022-.054-.022-.03 0-.052.006-.063.02-.012.013-.017.024-.013.038.003.01.003.019 0 .027s-.011.014-.021.014a.021.021 0 0 1-.017-.008.043.043 0 0 1-.007-.024c0-.021.011-.04.034-.059a.13.13 0 0 1 .084-.026c.034 0 .062.008.079.024.018.018.025.041.025.072v.223c0 .019.001.029.004.032s.007.005.016.005.015-.005.018-.015.005-.024.005-.042h.013a.115.115 0 0 1-.012.064zm.328-.29c-.004.008-.011.011-.02.011-.01 0-.017-.003-.021-.011a.036.036 0 0 1-.004-.026l-.002-.018c-.001-.003-.006-.006-.015-.006-.015 0-.031.011-.052.034a.309.309 0 0 0-.054.095v.183c0 .009.002.016.006.02s.01.007.018.007h.058v.021h-.194v-.021h.054c.009 0 .015-.002.019-.007s.005-.011.005-.02v-.28a.048.048 0 0 0-.005-.022c-.004-.005-.01-.008-.019-.008h-.054v-.02h.021a.199.199 0 0 0 .084-.018h.008v.122a.333.333 0 0 1 .057-.083.087.087 0 0 1 .062-.028c.018 0 .031.005.041.015s.015.02.015.034c-.001.012-.003.021-.008.026zm.745.18v.135c0 .047-.02.08-.058.098-.001-.033-.029-.058-.082-.073v-.014l.076.008c.017.001.023-.013.023-.042v-.112h-.212a.125.125 0 0 0-.053.01l-.021-.026h.287l-.002-.098.034.02.07-.077h-.217l-.023.01-.021-.027h.261l.029-.034.047.067c-.024-.004-.069.019-.137.071l.026.017-.026.021v.029h.177l.037-.047.053.064h-.268zm.269-.202c-.025 0-.046.014-.058.041a.414.414 0 0 1-.211-.256h-.015c0 .104.001.168.002.188l-.045.015c.002-.05.003-.111.003-.187a.584.584 0 0 1-.277.276l-.002-.015a.648.648 0 0 0 .242-.278h-.163a.125.125 0 0 0-.053.01l-.021-.027h.274l-.003-.121.068.037-.025.023v.061h.194l.037-.047.047.064h-.25a.324.324 0 0 0 .256.202v.014zm.681.364c-.035.014-.052.029-.048.051a2.29 2.29 0 0 1-.166 0 .415.415 0 0 1-.159-.034.311.311 0 0 1-.109-.078.402.402 0 0 1-.124.131l-.008-.01a.458.458 0 0 0 .113-.152.65.65 0 0 1-.063-.172l.011-.006a.785.785 0 0 0 .063.142c.018-.059.03-.136.037-.229h-.077l-.021.037-.036-.047.031-.018a3.97 3.97 0 0 0 .09-.198h-.086l-.03.01-.021-.027h.141l.023-.037.037.055-.029.017c-.029.061-.062.125-.095.192h.071l.021-.03.04.047-.023.023a1.169 1.169 0 0 1-.047.235.209.209 0 0 0 .094.064.49.49 0 0 0 .141.028c.053.005.13 0 .232-.008l-.003.014zm.65-.007c-.031.007-.05.024-.055.055a.694.694 0 0 1-.131-.067.394.394 0 0 1-.1-.103.491.491 0 0 1-.067-.17H5.98v.27l.142-.078.005.01a.562.562 0 0 0-.163.143l-.031-.057a.083.083 0 0 0 .013-.041v-.487c0-.036-.001-.067-.003-.094l.037.033h.134a.264.264 0 0 0-.045-.117l.005-.011c.044.025.069.047.075.067.006.02 0 .041-.018.061h.119l.021-.033.042.047-.024.02v.192l.002.088-.037.017v-.03H6.08a.516.516 0 0 0 .071.147.584.584 0 0 0 .164-.135l.039.067h-.031c-.053.023-.105.052-.161.08a.299.299 0 0 0 .123.087.387.387 0 0 0 .133.024l-.001.015z",
    opacity: 0.67
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: -1039.812,
    x2: -1039.812,
    y1: 1136.832,
    y2: 1136.901,
    gradientTransform: "matrix(1 0 0 -1 1045.93 1163.232)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#f8f8f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.427,
    stopColor: "#b1b1ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.435,
    stopColor: "#adaea8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.534,
    stopColor: "#898984"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.633,
    stopColor: "#6c6c67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.731,
    stopColor: "#53534e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.825,
    stopColor: "#3e3e3a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.916,
    stopColor: "#252523"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1b1a19"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#k)",
    d: "M5.98 26.276h.276v.118H5.98z",
    opacity: 0.67
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: -1823.484,
    x2: -1823.484,
    y1: 1134.524,
    y2: 1136.066,
    gradientTransform: "rotate(180 -892.47 581.616)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#f8f8f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.427,
    stopColor: "#b1b1ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.435,
    stopColor: "#adaea8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.534,
    stopColor: "#898984"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.633,
    stopColor: "#6c6c67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.731,
    stopColor: "#53534e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.825,
    stopColor: "#3e3e3a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.916,
    stopColor: "#252523"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1b1a19"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#l)",
    d: "M35.306 25.958h7.655a20.88 20.88 0 0 1-.749 2.625h-8.09c.48-.827.88-1.703 1.184-2.625z",
    opacity: 0.86
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M43.344 16.128c.504 1.729.72 3.528.72 5.4 0 1.944-.288 3.815-.72 5.616H.792v-.072h42.48c.504-1.8.72-3.672.72-5.616 0-1.872-.216-3.672-.648-5.328z"
  })), _radialGradient4 || (_radialGradient4 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "m",
    cx: -1043.936,
    cy: 1145.919,
    r: 27.789,
    gradientTransform: "matrix(1 0 0 -1 1045.93 1163.232)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1e71b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.082,
    stopColor: "#1c69ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.166,
    stopColor: "#1b64a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.242,
    stopColor: "#1a63a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.392,
    stopColor: "#185d98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.685,
    stopColor: "#0f4d80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.837,
    stopColor: "#004472"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.933,
    stopColor: "#014472"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.968,
    stopColor: "#064271"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.993,
    stopColor: "#0d3f6f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0f3d6e"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#m)",
    d: "M.72 16.056h42.624c.432 1.728.647 3.527.647 5.399 0 1.944-.216 3.816-.72 5.616H.792A20.735 20.735 0 0 1 0 21.456c0-1.872.288-3.672.72-5.4z"
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: -1003.294,
    x2: -1014.121,
    y1: 1151.811,
    y2: 1162.639,
    gradientTransform: "matrix(1 0 0 -1 1045.93 1163.232)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.006,
    stopColor: "#121209"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.646,
    stopColor: "#454441"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#484845"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.655,
    stopColor: "#535350"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#646561"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664,
    stopColor: "#7b7b77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.669,
    stopColor: "#969792"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.674,
    stopColor: "#bbbbb7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.678,
    stopColor: "#e8e7e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#fbfaf5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.682,
    stopColor: "#f8f7f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.684,
    stopColor: "#f0f0ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.685,
    stopColor: "#e4e3dd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.686,
    stopColor: "#d2d2cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.687,
    stopColor: "#bbbcb5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.689,
    stopColor: "#a0a19a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.689,
    stopColor: "#83847d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#6d6d67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.706,
    stopColor: "#5f5f5b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.732,
    stopColor: "#4d4d4b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.762,
    stopColor: "#3b3a3a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#242324"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.853,
    stopColor: "#101010"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#n)",
    d: "M38.304.719l4.752 4.753L39.528 9l.216.288-2.52 2.015-.792.289 5.184-5.256L37.44 2.16l-5.184 5.184.216-.72z"
  })), _radialGradient5 || (_radialGradient5 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "o",
    cx: -1004.186,
    cy: 1161.92,
    r: 11.613,
    gradientTransform: "matrix(1 0 0 -1 1045.93 1163.232)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#575652"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#52524e"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#o)",
    d: "M33.552.216c4.176 2.232 7.56 5.688 9.863 9.792V.216h-9.863z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#a7a79c",
    strokeLinecap: "round",
    strokeWidth: 0.34,
    d: "M33.552.216c4.176 2.232 7.56 5.688 9.863 9.792"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#c2c2b9",
    strokeLinecap: "round",
    strokeWidth: 0.236,
    d: "M33.552.216a24.642 24.642 0 0 1 9.792 9.792"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#e0e0d8",
    strokeLinecap: "round",
    strokeWidth: 0.132,
    d: "M33.48.216c4.176 2.232 7.56 5.688 9.864 9.864"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 0.028,
    d: "M33.48.216c4.104 2.305 7.56 5.688 9.792 9.864"
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: -1012.522,
    x2: -1002.37,
    y1: 1163.124,
    y2: 1163.124,
    gradientTransform: "matrix(1 0 0 -1 1045.93 1163.232)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5d5e60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.019,
    stopColor: "#5b5b5d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.205,
    stopColor: "#484846"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#343431"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.649,
    stopColor: "#222120"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1b1a19"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#p)",
    d: "M43.416 0c.072 0 .145.072.145.216H33.407c.001-.144.073-.216.145-.216h9.864z"
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: -1002.478,
    x2: -1002.478,
    y1: 1153.007,
    y2: 1163.231,
    gradientTransform: "matrix(1 0 0 -1 1045.93 1163.232)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5d5e60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.386,
    stopColor: "#464543"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742,
    stopColor: "#2a2927"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1b1a19"
  }))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#q)",
    d: "M43.56 10.008c0 .145-.072.217-.145.217l-.071-.145V0h.071c.072 0 .145.072.145.216v9.792z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M37.44 24.222c-1.922 0-3.485-1.177-3.485-2.622 0-1.446 1.563-2.622 3.485-2.622 1.962 0 3.558 1.176 3.558 2.622s-1.596 2.622-3.558 2.622zm0-4.464c-.691 0-1.194.775-1.194 1.843 0 1.009.514 1.77 1.194 1.77.646 0 1.194-.811 1.194-1.77.001-1.017-.536-1.843-1.194-1.843zm-21.888 4.464c-1.923 0-3.486-1.177-3.486-2.622 0-1.383 1.596-2.551 3.486-2.551 1.962 0 3.558 1.145 3.558 2.551 0 1.446-1.596 2.622-3.558 2.622zm0-4.392c-.682 0-1.194.761-1.194 1.771 0 1.009.514 1.77 1.194 1.77.646 0 1.193-.811 1.193-1.77s-.545-1.771-1.193-1.771zm12.816 4.248l-2.258-4.191-1.125.017-.03-.678 4.926-.03.03.678-1.254.03 1.754 2.907 1.459-2.951-.837.043-.03-.678 3.414-.03.03.678-1.182.03-2.214 4.176h-2.683zm-9 0l-.03-.822 1.183-.029-.03-3.354-1.122.03-.03-.678 4.566-.03.03.678-1.183.03.03 3.354 1.194-.029c.388 0 1.41-.254 1.481-1.412l.75-.028.03 2.292h-6.869zm-12.888 0l-2.258-4.191-1.125.017-.03-.678 4.926-.03.03.678-1.254.03 1.754 2.907 1.532-2.951-.91.044-.03-.678 3.414-.03.03.678-1.183.03-2.214 4.176-2.682-.002z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#39393c",
    d: "M37.44 19.008c1.944 0 3.528 1.152 3.528 2.593 0 1.439-1.584 2.592-3.528 2.592-1.872 0-3.456-1.152-3.456-2.592 0-1.441 1.584-2.593 3.456-2.593m0 4.392c.647 0 1.224-.792 1.224-1.8 0-1.08-.576-1.872-1.224-1.872-.72 0-1.225.792-1.225 1.872.001 1.008.505 1.8 1.225 1.8m-21.888-4.32c1.943 0 3.527 1.152 3.527 2.521 0 1.439-1.584 2.592-3.527 2.592-1.872 0-3.456-1.152-3.456-2.592 0-1.369 1.584-2.521 3.456-2.521m0 4.32c.647 0 1.224-.792 1.224-1.8 0-1.009-.576-1.801-1.224-1.801-.721 0-1.225.792-1.225 1.801.001 1.008.505 1.8 1.225 1.8m18.864-4.176v.647h-1.151l-2.232 4.176h-2.664l-2.231-4.176h-1.152v-.647h4.896v.647h-1.224l1.729 2.952 1.512-2.952h-.864v-.647h3.381m-10.512 0v.647h-1.152v3.384h1.225c.432 0 1.439-.288 1.512-1.439h.72v2.231h-6.841v-.792h1.152v-3.384h-1.152v-.647h4.536m-11.376 0v.647h-1.152l-2.231 4.176H6.48l-2.232-4.176H3.096v-.647h4.896v.647H6.768l1.728 2.952 1.584-2.952h-.936v-.647h3.384m24.912-.276c-1.938 0-3.517 1.189-3.517 2.652 0 1.462 1.577 2.651 3.517 2.651 1.979 0 3.588-1.188 3.588-2.651 0-1.464-1.61-2.652-3.588-2.652zm0 4.392c-.664 0-1.164-.748-1.164-1.739 0-1.051.489-1.812 1.164-1.812.642 0 1.164.813 1.164 1.812 0 .942-.533 1.739-1.164 1.739zm-21.888-4.32c-1.906 0-3.517 1.182-3.517 2.58 0 1.462 1.577 2.651 3.517 2.651 1.979 0 3.588-1.188 3.588-2.651 0-1.423-1.609-2.58-3.588-2.58zm0 4.32c-.664 0-1.164-.748-1.164-1.739 0-.992.5-1.74 1.164-1.74.631 0 1.163.797 1.163 1.74.001.942-.532 1.739-1.163 1.739zm18.924-4.176h-3.505V19.933H31.797L30.381 22.7l-1.619-2.768h1.18V19.163H24.925V19.932H26.1l2.215 4.144.017.032h2.736l.017-.032 2.216-4.144h1.176v-.768h-.001zm-10.512 0H19.308V19.933H20.46v3.264H19.308v.913H26.269V21.757h-.837l-.004.057c-.071 1.135-1.072 1.384-1.452 1.384h-1.164v-3.264H23.964v-.77zm-11.376 0H9.084V19.933H9.98l-1.486 2.77-1.621-2.77h1.181V19.164H3.036V19.933h1.176l2.216 4.144.017.032H9.18l.017-.032 2.215-4.144H12.588V19.164z"
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: -1040.044,
    x2: -1033.543,
    y1: 1150.544,
    y2: 1141.751,
    gradientTransform: "matrix(1 0 0 -1 1045.93 1163.232)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.109,
    stopColor: "#d5ddf0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.338,
    stopColor: "#94add9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.542,
    stopColor: "#668fc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.714,
    stopColor: "#447dbf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.848,
    stopColor: "#2a74ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.927,
    stopColor: "#1e71b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.947,
    stopColor: "#4079bc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.967,
    stopColor: "#5580c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.985,
    stopColor: "#6085c2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6486c3"
  }))), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#r)",
    d: "M.798 16.139c-.432 1.728-.72 3.527-.72 5.399 0 .155.053 1.072.058 1.227l.125 1.391c-.002-.112-.058-2.379-.058-2.492 0-1.872.312-3.607.744-5.336l15.083-.062 6.51-.125-21.742-.002z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolvo);
export default __webpack_public_path__ + "static/media/volvo.bdcd95dd18caa0cb8bca3434fb1decdd.svg";
export { ForwardRef as ReactComponent };